import { TDevice } from '@app/@types/myDevices'

export const reorderArray = (list: Array<TDevice>, startIndex: number, endIndex: number): Array<TDevice> => {
  const result = [...list]
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}
